/**
 * Build-time environment. VITE_API_BASE_URL is read from the shell when
 * `vite build` runs; falls back to the dev-server proxy prefix so a plain
 * `npm run dev` call "just works" against qa (the proxy in vite.config.ts
 * forwards /issuing/* to qa-api.withnelson.co).
 */
export const API_BASE_URL: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/issuing';

export const APP_ENV: 'test' | 'live' =
  ((import.meta.env.VITE_APP_ENV as string | undefined) ?? 'test') === 'live'
    ? 'live'
    : 'test';
